import { render, staticRenderFns } from "./NorticTabs.vue?vue&type=template&id=7a73f7e6&scoped=true&"
import script from "./NorticTabs.vue?vue&type=script&lang=js&"
export * from "./NorticTabs.vue?vue&type=script&lang=js&"
import style0 from "./NorticTabs.vue?vue&type=style&index=0&id=7a73f7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73f7e6",
  null
  
)

export default component.exports